<template>
  <div class="healing-card">
    <b-card-text>

      <!-- No data available or outside of healing period -->
      <template v-if="currentWaveAccomplished == null || !inHealingPeriod && healingStatus != 'in_progress'">
        <div class="mb-0">
          <MarginKpiHealingCardTitle :Title="$t('Webportal.CX.Margin.NoResults')" :AvailableHealings="availableHealings" />  
          <p>{{ $t('Webportal.CX.Margin.NextResultsOn', { PLACEHOLDER: nextHealingDate.toLocaleDateString("de-DE")})}}</p>
        </div>
      </template>
    
      <!-- Accomplished goals -->
      <template v-if="inHealingPeriod && currentWaveAccomplished && !healingStatus">
        <MarginKpiHealingCardTitle :Title="$t('Webportal.CX.Margin.SuccessfulQuarter')" :AvailableHealings="availableHealings" />
        <div class="mb-0">{{ $t('Webportal.CX.Margin.AccomplishedQuarter') }}</div>
      </template>

      <!-- Out of available healings -->
      <template v-if="inHealingPeriod && availableHealings == 0 && !currentWaveAccomplished && !healingStatus">
        <MarginKpiHealingCardTitle :Title="$t('Webportal.CX.Margin.NoHealings')" :AvailableHealings="availableHealings" />
        <div class="mb-0">{{ $t('Webportal.CX.Margin.OutOfHealings') }}</div>
      </template>

      <!-- Healing is finished -->
      <template v-if="healingStatus=='finished'">
        <MarginKpiHealingCardTitle :Title="$t('Webportal.CX.Margin.HealingFinished')" :AvailableHealings="availableHealings" />
        <div class="mb-0">
          {{ $t('Webportal.CX.Margin.HealingFinishedText', { PLACEHOLDER: activeHealingDate.toLocaleDateString("de-DE")})}}
          </div>
      </template>

      <!-- Healing in progress -->
      <template v-if="healingStatus == 'in_progress'">
        <MarginKpiHealingCardTitle :Title="$t('Webportal.CX.Margin.HealingInProgress')" :AvailableHealings="availableHealings" />
        <div class="mb-0">
          <p>{{ $t('Webportal.CX.Margin.HealingInProgressText', { PLACEHOLDER: activeHealingDate.toLocaleDateString("de-DE")})}}</p>
          <b-button size="sm" variant="outline-primary" @click="toggleHelp()">
            {{ $t('Webportal.CX.Margin.Hints')}}
          </b-button>
        </div>
      </template>

      <!-- Healing possible -->
      <template  v-if="inHealingPeriod && availableHealings > 0 && !currentWaveAccomplished && !healingStatus && currentWaveAccomplished != null">
        <MarginKpiHealingCardTitle :Title="$t('Webportal.CX.Margin.HealingPossible')" :AvailableHealings="availableHealings" />

        <div class="mb-0">
          <p v-if="isPreHealingPhase">{{$t('Webportal.CX.Margin.MissedMarginGoalsText2')}}</p>
          <p v-if="!isPreHealingPhase">{{$t('Webportal.CX.Margin.MissedMarginGoalsText')}}</p>
          <b-button size="sm" @click="startHeal()" :disabled="isPreHealingPhase">
            <i class="far fa-ambulance mr-1 heal-icon" style="transform: scale(-1, 1)"></i>
            {{ $t('Webportal.CX.Margin.Heal') }}
          </b-button>
          <b-button size="sm" variant="link" @click="toggleHelp()">
            {{ $t('Webportal.CX.Margin.Hints')}}
          </b-button>
        </div>
      </template>
        
      <MarginHealPopup 
        v-if="showHealPopup"
        :ClientLocationId="clientLocationId"
        :WaveName="currentWave"
        :KpiGroup="kpiGroup"
        :Year="new Date().getFullYear() "
        :Brand="brand"
        @close="hideHealPopup()"
      />
    </b-card-text>
  </div>
</template>

<script>
import DashboardService from "@/services/DashboardService";
import MarginHealPopup from "./MarginHealPopup.vue";
import MarginKpiHealingCardTitle from "./MarginKpiHealingCardTitle.vue";
import EventBus from "@/services/EventBus";

export default {
  components: {
    DashboardService,
    MarginHealPopup,
    MarginKpiHealingCardTitle
  },
  props: {
    clientLocationId: Number,
    currentWave: String,
    kpiGroup: Object,
    brand: String,
    currentWaveAccomplished: {
      type: Boolean,
      default: false
    }
  },
  created: function() {
    DashboardService.getHealingStatus(this.clientLocationId, this.brand)
      .then((res) => {
        this.inHealingPeriod = res.data.inHealingPeriod;
        this.nextHealingDate = new Date(res.data.nextHealingDate);
        this.activeHealingDate = new Date(res.data.activeHealingDate);
        this.availableHealings = res.data.availableHealings;
        this.healingStatus = res.data.healingStatus;
      });
  },
  computed: {
    isPreHealingPhase() {
      // Disable but show healing button in the last two weeks of a quarter
      // and enable it on the second day after a quarter has finished.
      var m = new Date().getMonth() + 1;
      var d = new Date().getDate();
      return !((m == 4 || m == 7 || m == 10 || m == 1) && d > 1);
    }
  },
  data() {
    return {
      showHealPopup: false,
      inHealingPeriod: false,
      nextHealingDate: new Date(),
      activeHealingDate: new Date(),
      availableHealings: null,
      healingStatus: null
    };
  },
  methods: {
    startHeal() {
      this.showHealPopup = true;
    },
    hideHealPopup() {
      this.showHealPopup = false;
    },
    toggleHelp() {
      EventBus.$emit('toggle-healing-help')
    }
  }
};
</script>

<style scoped>
p {
  margin-block-start: 0em;
  margin-block-end: 0em;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
}

.help-icon-bd {
  margin: 0.4rem!important;
}
</style>